<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Matriz</h4>
      </div>
      <div>

        <fg-input name="Nome"
          v-validate="modelValidations.name"
           label="Nome" v-model="model.name"></fg-input>

        <fg-input name="Nome"
          v-validate="modelValidations.name"
          label="Razão social" v-model="model.trade_name"></fg-input>

        <fg-input name="CNPJ"
          @blur="validarCNPJ(model.cnpj)"
          maxlength="14"
          placeholder="Apenas os números"
          label="CNPJ" v-model="model.cnpj"></fg-input>

        <!-- <fg-input name="Email" 
          v-validate="modelValidations.email"
          v-if="crud === 'Criar'" label="E-mail" v-model="model.email"></fg-input>

          <fg-input name="Email" 
          v-validate="modelValidations.email"
          v-if="crud === 'Editar'" readonly label="E-mail" v-model="model.email"></fg-input> -->
        
          <!-- <fg-input
            name="company"
            label="Sistema de vendas">

            <el-select class=""
                        size="large"
                        style="width: 100%"
                        placeholder="Selecione o sistema de venda à ser utilizado"
                        v-model="model.payment_methods">
              <el-option v-for="option in vmSystem"
                          class=""
                          :value="option.value"
                          :label="option.label"
                          :key="option.id">
              </el-option>
            </el-select>
          </fg-input> -->

          <el-checkbox @input="confirm()" 
            v-if="ciaID"
            v-model="model.is_active">Empresa Ativa</el-checkbox>
          <br>
          <!-- <el-checkbox  v-model="paymentSystem">Possui máquina com pagamento via MercadoPago</el-checkbox> -->
        
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, Checkbox } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
  },
  mounted() {
    // this.$store.dispatch("sales/list")
    const ciaID = localStorage.getItem('smartmachCiaID')
    this.ciaID = ciaID
    if (ciaID) {
      this.ciaID = true
    } else {
      this.ciaID = false
    }
    if (this.$route.params.id) {
      this.$store.dispatch("parent/get", {id: this.$route.params.id}).then(data => {
        if (data.payment_methods === 'MP') {
          this.paymentSystem = true
        } else {
          this.paymentSystem = false
        }
        this.model = data
      });
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
  },
  computed: {
    sales() {
      return this.$store.state.sales.sales;
    }
  },
  data() {
    return {
      crud: "Editar",
      featureFlag: [],
      ciaID: false,
      paymentSystem: false,
     
      model: {
        name: '',
        payment_methods: '',
        notification_url: ''

      },
      modelValidations: {
        email: {
          required: true
        },
        name: {
          required: true
        },
      }
    };
  },
  methods: {
    localeDate(date) {
      const d = new Date(date);
      return d.toLocaleString("pt-BR");
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyAlert() {
      this.$notify({
        message: "Opa!</br>Preencha pelo menos os campos de nome e e-mail!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "warning"
      });
    },
    notifyError() {
      this.$notify({
        message: "Opa!</br>Edição não salva!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validarCNPJ(cnpj) {
 
      cnpj = cnpj.replace(/[^\d]+/g,'');
  
      if(cnpj == '') {
        alert('CNPJ inválido')
        return false;
      }
      
      if (cnpj.length != 14) {
        alert('CNPJ inválido')
        return false;
      }
  
      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" || 
          cnpj == "11111111111111" || 
          cnpj == "22222222222222" || 
          cnpj == "33333333333333" || 
          cnpj == "44444444444444" || 
          cnpj == "55555555555555" || 
          cnpj == "66666666666666" || 
          cnpj == "77777777777777" || 
          cnpj == "88888888888888" || 
          cnpj == "99999999999999") {
          alert('CNPJ inválido')
          return false;
      }

      var tamanho, numeros, digitos, soma, pos, resultado
          
      // Valida DVs
      tamanho = cnpj.length - 2
      numeros = cnpj.substring(0,tamanho);
      digitos = cnpj.substring(tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0)) {
        alert('CNPJ inválido')
        return false;
      }
          
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) {
        alert('CNPJ inválido')
        return false;
      }
     
      return true;
        
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (this.paymentSystem) {
          this.model.payment_methods = 'MP'
        } else {
          this.model.payment_methods = 'VM'
        }
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("parent/create", { item: this.model })
            .then(resp => {
              console.log('res', resp)
              this.notifySuccess();
              this.$router.push(`/app/matrizes`);
            });
        } else if (isValid && this.crud === "Editar") {
          console.log("customer", this.model);
          this.$store
            .dispatch("parent/update", { item: this.model })
            .then(resp => {
              console.log('resp', resp)
              if (resp.id) {
                this.notifySuccess();
                this.$router.push(`/app/matrizes`);
              } else {
                this.notifyError()
                this.$router.push(`/app/matrizes`);
              }
            })
        } else {
          this.notifyAlert();
        }
      });
    },
    confirm () {
      if (!this.model.is_active) {
        swal.fire({
          title: "Tem certeza?",
          text: `Você está prestes a bloquear a empresa. Todos os endpoints serão bloqueados!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim, bloqueie!",
          cancelButtonText: "Cancelar",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            swal.fire({
              title: "Pronto!",
              text: `Empresa será bloqueada ao salvar.`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            this.model.is_active = false
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Empresa não será bloqueada ao salvar.`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
            this.model.is_active = true
          }
        });
      }
    },
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
